// extracted by mini-css-extract-plugin
module.exports = {"ProductSave":"ProductSave--1BXZQ","header":"header--7oYvj","content":"content--9fAOe","wrap":"wrap--2wK35","tips":"tips--108wu"};